var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/log-out"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.33203 23.9998H8.94414C10.8245 25.6594 13.2945 26.6665 15.9997 26.6665C21.8907 26.6665 26.6663 21.8909 26.6663 15.9998C26.6663 10.1088 21.8907 5.33317 15.9997 5.33317C13.2945 5.33317 10.8245 6.3402 8.94414 7.99984H5.33203C7.76458 4.76132 11.6375 2.6665 15.9997 2.6665C23.3634 2.6665 29.333 8.63604 29.333 15.9998C29.333 23.3636 23.3634 29.3332 15.9997 29.3332C11.6375 29.3332 7.76458 27.2384 5.33203 23.9998Z",
    fill: "#EA1763"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 75",
    d: "M6.66667 10.6665L0 15.9998L6.66667 21.3332V17.3332H17.3333V14.6665H6.66667V10.6665Z",
    fill: "#F28520"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOut);
export default __webpack_public_path__ + "static/media/log-out.f83b5754b0ad41a3b70e546735f7ff66.svg";
export { ForwardRef as ReactComponent };